// extracted by mini-css-extract-plugin
export var indeterminate = "_4r-5";
export var md = "_4r-4";
export var semantic = "_4r-6";
export var sm = "_4r-3";
export var text = "_4r-7";
export var toggleInput = "_4r-0";
export var toggleSwitch = "_4r-1";
export var xs = "_4r-2";